module.exports = "/_next/static/images/Frame2Mobile-150a3a16d99027ffccfb9b217f30d9ca.webp";